import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `SaleExport/${dossierId}`, method: 'GET', token: token })
}
